import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseCompanyUsersProps<T> = {
  filters?: {
    search?: string
    page?: number
    companyId?: string
    branchId?: string
    roleId?: string
    status?: string
    allowedToConsumeOnEquipmentId?: string
    showDescendants?: boolean
  }
  mapper?: (data: any) => T,
}

export const useCompanyUsers = <T,>({
  filters: { search = '', page, companyId, branchId, roleId, status, allowedToConsumeOnEquipmentId, showDescendants } = {},
  mapper = Mapper.default<T>(),
}: UseCompanyUsersProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['companyUsers', search, page, companyId, branchId, roleId, status, allowedToConsumeOnEquipmentId, showDescendants],
    queryFn: () => {
      return privateAxios.get('/client/users', {
        params: {
          search,
          page,
          'q[company_id_eq]': companyId,
          'q[company_branch_id_eq]': branchId,
          'q[role_id_eq]': roleId,
          'q[status_eq]': status,
          'q[allowed_to_consume_on_equipment_id_eq]': allowedToConsumeOnEquipmentId,
          'q[show_from_descendants]': showDescendants,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
